module.exports = __webpack_public_path__ + "d5833666c3523a5b4c256ca5ea771265.svg";